// extracted by mini-css-extract-plugin
export default {"Error":"Error_Error__dm9ox","AppLogo":"Error_AppLogo__duJJw","AppHeader":"Error_AppHeader__MQQCq","App-link":"Error_App-link__KMTlJ","Safety":"Error_Safety__J4Sfz"};